import { defineMessages } from 'react-intl'

const scope = `procurify.expense.presenter.DuplicateExpenseReportPresenter`

export default defineMessages({
  confirmTitle: {
    id: `${scope}.confirmTitle`,
    defaultMessage: 'Confirmation',
  },
  confirmMessage: {
    id: `${scope}.confirmMessage`,
    defaultMessage:
      'This action will overwrite the previous expense report draft.',
  },
  confirmButton: {
    id: `${scope}.confirmButton`,
    defaultMessage: 'Confirm',
  },
  duplicateSuccess: {
    id: `${scope}.duplicateSuccess`,
    defaultMessage: 'Expense report duplicated',
  },
})
